import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-segmented-control]')) return;

  addEventListeners();
}

function addEventListeners() {
  const segmentedControls = $$('[data-au-segmented-control]');

  segmentedControls.forEach((segControl) => {
    segControl.addEventListener('click', (e) => {
      const input = e.currentTarget.querySelector('input');
      const isCheckbox = input.type === 'checkbox';
      const isChecked = e.target === input ? input.checked === false : input.checked === true;

      if (input) {
        if (isCheckbox && isChecked) {
          input.checked = false;
        } else {
          input.checked = true;
        }
      }
    });
  });
}

export default { init };
